import { unauthorizedClient } from './clients/unauthorizedClient'

export const generateUnauthorizedToken = async () => {
    const { data } = await unauthorizedClient.post('/guest/generate-token')
    return data.token
}

export const verifyUnauthorizedToken = async (token: string) => {
    const { data } = await unauthorizedClient.post('/guest/verify-token', { token })
    return data.payload
}
